import { ComponentBase, component } from "@sygnal/sse-core";

@component('secondary-btn')
export class SecondaryBtnComponent extends ComponentBase {

  protected async onLoad(): Promise<void> {
    this.injectShineStyles();
  }

  private injectShineStyles(): void {
    const style = document.createElement("style");
    style.textContent = [
      ".secondary_btn-ghost { position: relative; overflow: hidden; }",
      ".secondary_btn-ghost::before { content: ''; position: absolute; top: 0; left: -125%; width: 60%; height: 100%; background: rgba(255,255,255,0.4); transform: skewX(-45deg); transition: left 500ms ease-out; pointer-events: none; }",
      ".secondary_btn-ghost:hover::before { left: 150%; }",
    ].join(" ");
    document.head.appendChild(style);
  }
}
